import React from "react";
import { AiOutlineFilePdf } from "react-icons/ai";
import { FaFileAlt } from "react-icons/fa";

const FileGrid = ({ files, collapsed }) => {
  const getFileIcon = (file) => {
    if (!file) return null;

    if (file.fileType?.startsWith("image/")) {
      return (
        <img
          src={file.signedUrl || file.signedThumbUrl}
          alt={file.fileName}
          className="w-full h-full object-cover rounded"
          onError={(e) => {
            e.target.src = "/fallback-image.png";
          }}
        />
      );
    }
    if (file.fileType === "application/pdf") {
      return <AiOutlineFilePdf className="text-5xl text-gray-500" />;
    }
    return <FaFileAlt className="text-5xl text-gray-500" />;
  };

  const handleImageClick = (ad) => {
    window.open(ad.redirectUrl, "_blank");
  };

  return (
    <div
      className={`flex-1 grid gap-4 mt-5
    ${collapsed ? "md:grid-cols-[repeat(auto-fill,minmax(300px,1fr))]" : "md:grid-cols-[repeat(auto-fill,minmax(300px,1fr))]"}
  `}
    >
      {files?.map((ad) => (
        <div
          key={ad.adId}
          className="rounded-lg cursor-pointer w-[300px] h-[250px] shadow-md hover:shadow-lg transition duration-150 mx-auto"
          onClick={() => handleImageClick(ad)}
        >
          {/* Fixed 300x250 container */}
          <div className="rounded w-full h-full flex items-center justify-center overflow-hidden">
            {getFileIcon(ad.media)}
          </div>
        </div>
      ))}
    </div>

  );
};

export default FileGrid;
